<div class="h-100" (click)="enterEditMode()">
  <div
    class="d-flex align-items-center h-100"
    [ngClass]="{'justify-content-between': dateConfig?.justifyContentForDisplay}"
  >
    <span>
      {{ context.data[context.column.columnDef] | date: (dateConfig?.format ??
      Constants.DefaultValues.dateDisplayFormat) }}
    </span>
    <mat-icon svgIcon="calendar" class="ml-1 custom-icon-position icon--primary"></mat-icon>
  </div>
  <input
    style="visibility: hidden; height: 0"
    [matDatepicker]="picker"
    [min]="minDate"
    [max]="maxDate"
    [(ngModel)]="selectedDate"
    (ngModelChange)="save()"
  />
  <mat-datepicker-toggle class="display-none" matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker data-testId="date-picker" #picker>
    <div>
      <button data-testId="clear-calendar" mat-button color="primary" class="button--small" (click)="clear()">
        {{clearButtonLabel ?? 'Clear'}}
      </button>
    </div>
    <mat-datepicker-actions *ngIf="timeOptions?.allowTimePicker || colorOptions?.allowColorPicker">
      <div *ngIf="timeOptions?.allowTimePicker">
        <div #timePicker class="d-flex w-100 border-top pt-1">
          <ng-container
            *ngTemplateOutlet="timeOptions?.timePickerComponent; context: {
              $implicit: {
                selectedTime,
                timeChanged: onTimeChanged.bind(this)
              }
            }"
          ></ng-container>
        </div>
      </div>

      <div *ngIf="colorOptions?.allowColorPicker">
        <div #colorPicker class="border-bottom pt-1 mx-n3 px-2">
          <div class="border-top mx-2"></div>
          <app-color-picker
            [options]="colorOptions"
            [context]="context"
            [isEditMode]="datepicker.opened"
            [isExternalSave]="true"
            (colorSelected)="onColorChanged($event)"
          ></app-color-picker>
        </div>
      </div>
      <div class="buttonsWrapper pt-2">
        <button
          data-testId="save-date-time-selection"
          mat-flat-button
          color="secondary"
          class="button--small"
          matDatepickerApply
          (click)="save()"
        >
          <mat-icon svgIcon="check"></mat-icon>
          {{saveButtonLabel ?? "Save"}}
        </button>
        <button
          data-testId="clear-calendar"
          mat-button
          color="primary"
          class="button--small"
          (click)="clear()"
          matDatepickerCancel
        >
          {{clearButtonLabel ?? 'Clear'}}
        </button>
      </div>
    </mat-datepicker-actions>
  </mat-datepicker>
</div>

<div class="display-none">
  <div #clearBtn class="d-flex w-100 p-2">
    <button mat-button color="primary" class="qa-calendar-clear-btn button--small" (click)="clear()">
      {{clearButtonLabel ?? 'Clear'}}
    </button>
  </div>
</div>
